export const DISPLAY_MAPPING = {
    block: 'flex',
    inline: 'inline-flex'
};
//# sourceMappingURL=types.js.map